import http from "@/http-common";

/* eslint-disable */
class PcFileDataService {
  upload(data: any): Promise<any> {
    return http.api.post("/pcupload/", data);
  }
  allDownload(data: any): Promise<any> {
    return http.api.post("/pcalldownload/", data);
  }
  setDownloadFlag(data: any): Promise<any> {
    return http.api.post("/pcsetdownloadflag/", data);
  }
  getUploadHistory(data: any): Promise<any> {
    return http.api.post("/getUploadHistory/", data);
  }
  getFileFormatList(): Promise<any> {
    return http.api.post("/getFileFormatList/");
  }
}
export default new PcFileDataService();
